import { search_marketplace } from "../constants/endpoints"

export default async params => {
  const { data } = await search_marketplace(params)

  return data
}